import React from 'react';
import { Link } from 'react-router-dom';
import collage from 'images/stories_homepage.png';


import './style.css';

const HomeStories = () => {

  return (
    <div className="home-stories">
      <p>Discover some real-life examples of Airqast products.</p>
      <Link className="c-button -stories" to="/stories">Know more</Link>
      <div className="home-stories-images">
        <img src={collage} alt="stories" className="stories-item"/>
      </div>
    </div>

  );
};

export default HomeStories;



// WEBPACK FOOTER //
// ./src/pages/home/home-stories/index.js